import {createSvgIcon} from '../create-svg-icon';

export const SkipPreviousIcon = createSvgIcon(
  <path d="M6 6h2v12H6zm3.5 6 8.5 6V6l-8.5 6zm6.5 2.14L12.97 12 16 9.86v4.28z" />
, 'SkipPreviousOutlined');
